import {cloneDeep} from 'lodash';
import {PatientAction, PatientState, PatientStatusEnum} from '../../models/patient';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Store} from '@ngxs/store';
import {AuthActions, IAuthToken, IUser} from '../../models/auth';
import {StorageService} from '../../services/storage/storage.service';
import {FadeRoute} from '../../animations/routeFade.animation';
import {firstValueFrom} from 'rxjs';
import {UserService} from '../../services/user/user.service';

@Component({
  selector: 'app-auth-page-template',
  templateUrl: './auth-page-template.component.html',
  styleUrls: ['./auth-page-template.component.scss'],
  animations: [
    FadeRoute,
  ]
})
export class AuthPageTemplateComponent implements OnInit {
  title: string;
  subtitle: string;
  isVisibleModalNotAllowedAccess: boolean;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private store: Store,
    private storageService: StorageService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.initValuesHttp().then();
  }

  async initValuesHttp(): Promise<void> {
    const userToken: IAuthToken = this.storageService.getLocalItem<{ token: string, user: IUser }>('user');
    if (!userToken) {
      return;
    }
    if ((!userToken || !userToken.user || !userToken.token) || (!userToken?.user?.patients && !userToken?.user?.experts)) {
      return;
    }
    const childParams: Params = await this.activatedRoute.snapshot.children[0]?.params;
    await firstValueFrom((this.store.dispatch(new AuthActions.SetUser(userToken.user))));
    const clinicId = (childParams?.clinicId && childParams.clinicId !== 'guest') ?
      childParams.clinicId : userToken.user.experts ? userToken.user.experts[0].clinicId : userToken.user.patients[0].clinicId;
    const url: string = this.router.url;
    /**
     * si en la ruta viene recovery/token quiere decir que se ha abierto un link de invitación
     * si el usuario tiene una sesión cuando abre el link se tiene que verificar si es a una clínica diferente,
     * si es una clínica diferente entonces quita la sesión de local storage para poder abrir la vista de cambio de password
     * si es la misma clínica entonces solo hará un redireccionamiento al summary page
     */
    if (url.includes('recovery/token') && childParams?.clinicId !== this.userService.getClinicIdFromUser(userToken.user)) {
      this.storageService.clearAll();
      return;
    }
    const queryParams: Params = this.activatedRoute.snapshot.queryParams;
    const userInvitedFromAnotherClinic: boolean = (queryParams.new === 'false' || queryParams.new === 'true');
    const modeInvite: boolean = queryParams.invite === 'true';
    const [patient] = userToken?.user.patients ?? [];
    let hasNotHabits = false;
    if (patient) {
      await firstValueFrom(this.store.dispatch(new PatientAction.HasCompletedOnboarding(patient._id)));
      const expertId = cloneDeep(await firstValueFrom(this.store.selectOnce(PatientState.getPatientHasCompletedOnboarding)))?.expertId;
      if (expertId) {
        this.storageService.setLocalItem('expertId', expertId);
        hasNotHabits = true;
      }
    }
    // hacer petición para saber si el paciente no ha modificado sus hábitos
    // vendrá un objeto {expertId: string} si es null mandar directo a summary, si tiene un valor ponerlo
    // en LS y redirigir al onboarding
    const statusActive = userToken?.user?.patients ? patient.status === PatientStatusEnum.ACTIVE : false;
    if (patient?.status === PatientStatusEnum.PRECREATED || hasNotHabits || (userInvitedFromAnotherClinic && patient.clinicId !== clinicId) || modeInvite) {
      await this.router.navigate(['clinic', 'onboarding', clinicId], {
        queryParams: { invite: userInvitedFromAnotherClinic + '', hasNotHabits: hasNotHabits && statusActive }
        // antes solo tenia invite: true
      });
      return;
    } else {
      await this.router.navigate([`/clinic/${clinicId}/summary`]);
    }
  }
}
